import React from 'react';

const STATUS_CONFIG = {
  // Payment / chargeback statuses
  completed: { label: 'Completed', className: 'bg-green-500/15 text-green-400 border-green-500/30' },
  pending: { label: 'Pending', className: 'bg-yellow-500/15 text-yellow-400 border-yellow-500/30' },
  failed: { label: 'Failed', className: 'bg-red-500/15 text-red-400 border-red-500/30' },

  // Escrow statuses
  available: { label: 'Pending', className: 'bg-yellow-500/15 text-yellow-400 border-yellow-500/30' },
  eligible: { label: 'Eligible', className: 'bg-green-500/15 text-green-400 border-green-500/30' },
  broadcast: { label: 'Broadcast', className: 'bg-blue-500/15 text-blue-400 border-blue-500/30' },
  spent: { label: 'Spent', className: 'bg-gray-500/15 text-gray-400 border-gray-500/30' },

  // Generic
  active: { label: 'Active', className: 'bg-green-500/15 text-green-400 border-green-500/30' },
  inactive: { label: 'Inactive', className: 'bg-gray-500/15 text-gray-400 border-gray-500/30' },
};

export default function StatusBadge({ status }) {
  const config = STATUS_CONFIG[status] || {
    label: status,
    className: 'bg-gray-500/15 text-gray-400 border-gray-500/30',
  };

  return (
    <span className={`inline-flex items-center px-2 py-0.5 rounded-md text-xs font-medium border ${config.className}`}>
      <span className="w-1.5 h-1.5 rounded-full bg-current mr-1.5 opacity-80" />
      {config.label}
    </span>
  );
}
